import type { EnvironmentName, EnvironmentData } from '@cld/unicorn-api';

const environmentHostPatterns: Record<EnvironmentName, (host: string) => boolean> = {
  localhost: (subdomain) => subdomain === 'localhost',
  development: (subdomain) => subdomain === 'dev' || subdomain === 'console-dev',
  nightly: (subdomain) => subdomain === 'nightly' || subdomain === 'console-nightly',
  staging: (subdomain) => subdomain.startsWith('staging') || subdomain.startsWith('console-staging'),
  production: (subdomain) => subdomain === 'production' || subdomain === 'console-production',
  eod: (subdomain) => subdomain.startsWith('eod4') || subdomain.startsWith('console-eod4'),
};

export const getEnvironmentData = (url: string): EnvironmentData => {
  const parsedUrl = new URL(url);
  const subdomain = parsedUrl.hostname.split('.')[0];

  // FIXME: replace this solution with a cleaner UI-based variant (this is temporary for backward compability)
  const envOverride = localStorage.getItem('env');
  if (envOverride) {
    return {
      name: 'localhost',
      origin: `https://${envOverride}.cloudinary.com`,
      backendUrls: { console: `https://${envOverride}.cloudinary.com/console/api/v1` },
      unicornSystemVariant: 'applicationWrapper',
    };
  }

  if (environmentHostPatterns.eod(subdomain)) {
    const eodName = subdomain.split('eod4')[1];
    return {
      name: 'eod',
      origin: `https://console-eod4${eodName}.cloudinary.com`,
      backendUrls: { console: `https://console-eod4${eodName}.cloudinary.com/console/api/v1` },
      unicornSystemVariant: 'applicationWrapper',
    };
  }

  if (environmentHostPatterns.localhost(subdomain)) {
    return {
      name: 'localhost',
      origin: 'https://console-staging.cloudinary.com',
      backendUrls: { console: 'https://console-staging.cloudinary.com/console/api/v1' },
      unicornSystemVariant: 'applicationWrapper',
    };
  }

  if (environmentHostPatterns.development(subdomain)) {
    return {
      name: 'development',
      origin: 'https://console-dev.cloudinary.com',
      backendUrls: { console: 'https://console-dev.cloudinary.com/console/api/v1' },
      unicornSystemVariant: 'applicationWrapper',
    };
  }

  if (environmentHostPatterns.nightly(subdomain)) {
    return {
      name: 'nightly',
      origin: 'https://console-nightly.cloudinary.com',
      backendUrls: { console: 'https://console-nightly.cloudinary.com/console/api/v1' },
      unicornSystemVariant: 'applicationWrapper',
    };
  }

  if (environmentHostPatterns.staging(subdomain)) {
    const stagingOrdinal = subdomain.split('staging')[1];
    return {
      name: 'staging',
      origin: `https://console-staging${stagingOrdinal}.cloudinary.com`,
      backendUrls: { console: `https://console-staging${stagingOrdinal}.cloudinary.com/console/api/v1` },
      unicornSystemVariant: 'applicationWrapper',
    };
  }

  return {
    name: 'production',
    origin: `https://console.cloudinary.com`,
    backendUrls: { console: 'https://console.cloudinary.com/console/api/v1' },
    unicornSystemVariant: 'applicationWrapper',
  };
};
